
        import { createElement } from 'react';
        import { render } from 'react-dom';
        import 'wix/scripts/dashboard-asset/983e2133-1af8-43fe-9721-c70927e1f812.js';

        async function main() {
          const getComponent = await window['__module_federation__containers']['bd59b79d-a12b-406d-914a-b85843e83362'].get('983e2133-1af8-43fe-9721-c70927e1f812');
          render(createElement(getComponent().default), document.getElementById('root'));
        }

        main();
      